import React, { useState, Children } from 'react';
import { ShoppingBagIcon, HeartIcon, TagIcon } from 'lucide-react';
export function MarketplaceSection() {
  const [activeTab, setActiveTab] = useState('selling');
  const marketplaceItems = {
    selling: [{
      id: 1,
      name: 'Denim Jacket',
      price: '$45',
      image: 'https://images.unsplash.com/photo-1551537482-f2075a1d41f2?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      seller: 'Emma S.',
      condition: 'Like New'
    }, {
      id: 2,
      name: 'Leather Boots',
      price: '$65',
      image: 'https://images.unsplash.com/photo-1608256246200-53e635b5b65f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      seller: 'Michael T.',
      condition: 'Good'
    }, {
      id: 3,
      name: 'Wool Coat',
      price: '$85',
      image: 'https://images.unsplash.com/photo-1544022613-e87ca75a784a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      seller: 'Sarah K.',
      condition: 'Excellent'
    }, {
      id: 4,
      name: 'Summer Dress',
      price: '$30',
      image: 'https://images.unsplash.com/photo-1496747611176-843222e1e57c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      seller: 'Jessica M.',
      condition: 'Like New'
    }],
    donating: [{
      id: 5,
      name: 'Winter Sweaters',
      image: 'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      charity: 'Goodwill',
      condition: 'Good'
    }, {
      id: 6,
      name: "Children's Clothes",
      image: 'https://images.unsplash.com/photo-1519238360766-f5f7e7d77b0c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      charity: 'Salvation Army',
      condition: 'Mixed'
    }, {
      id: 7,
      name: 'Shoes Collection',
      image: 'https://images.unsplash.com/photo-1560343090-f0409e92791a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      charity: 'Local Shelter',
      condition: 'Used'
    }, {
      id: 8,
      name: 'Business Attire',
      image: 'https://images.unsplash.com/photo-1598522325074-042db73aa4e6?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      charity: 'Dress for Success',
      condition: 'Good'
    }]
  };
  return <div className="bg-white rounded-xl shadow-md p-6" data-id="element-38">
      <div className="flex items-center mb-6" data-id="element-39">
        <ShoppingBagIcon className="h-6 w-6 text-indigo-600 mr-2" data-id="element-40" />
        <h2 className="text-xl font-semibold text-gray-800" data-id="element-41">Marketplace</h2>
      </div>
      <div className="flex border-b border-gray-200 mb-6" data-id="element-42">
        <button className={`px-4 py-2 text-sm font-medium ${activeTab === 'selling' ? 'border-b-2 border-indigo-600 text-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('selling')} data-id="element-43">
          Items For Sale
        </button>
        <button className={`px-4 py-2 text-sm font-medium ${activeTab === 'donating' ? 'border-b-2 border-indigo-600 text-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('donating')} data-id="element-44">
          Items Being Donated
        </button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-45">
        {marketplaceItems[activeTab].map(item => <div key={item.id} className="bg-gray-50 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition" data-id="element-46">
            <div className="aspect-w-4 aspect-h-5" data-id="element-47">
              <img src={item.image} alt={item.name} className="object-cover w-full h-full" data-id="element-48" />
            </div>
            <div className="p-4" data-id="element-49">
              <h3 className="text-sm font-medium text-gray-900" data-id="element-50">{item.name}</h3>
              {activeTab === 'selling' ? <div className="mt-2 flex justify-between items-center" data-id="element-51">
                  <div className="flex items-center" data-id="element-52">
                    <TagIcon className="h-4 w-4 text-gray-500 mr-1" data-id="element-53" />
                    <span className="text-sm font-medium text-gray-900" data-id="element-54">
                      {item.price}
                    </span>
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-55">
                    {item.condition}
                  </span>
                </div> : <div className="mt-2 flex justify-between items-center" data-id="element-56">
                  <div className="flex items-center" data-id="element-57">
                    <HeartIcon className="h-4 w-4 text-red-500 mr-1" data-id="element-58" />
                    <span className="text-xs text-gray-600" data-id="element-59">
                      {item.charity}
                    </span>
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-60">
                    {item.condition}
                  </span>
                </div>}
              <div className="mt-4" data-id="element-61">
                <button className="w-full bg-indigo-600 text-white text-sm py-1.5 rounded-md hover:bg-indigo-700 transition" data-id="element-62">
                  {activeTab === 'selling' ? 'Contact Seller' : 'Learn More'}
                </button>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}